import { atom } from "@reatom/framework";
import { withLocalStorage } from "@reatom/persist-web-storage";
import { getMeRequest } from "src/store/fetchers";

import { RELEASE_DATE } from "../../constants";

export const disableWelcomeModal = atom(false, "disableWelcomeModal").pipe(
  withLocalStorage("disableWelcomeModal"),
);

export const openWelcomeModal = atom((ctx) => {
  const isDisableWelcomeModal = ctx.spy(disableWelcomeModal);

  const userInfo = ctx.spy(getMeRequest.dataAtom);

  if (!userInfo) return false;

  if (isDisableWelcomeModal) return false;

  const createdAt = new Date(userInfo.createdAt).getTime();
  const timestamp = Date.now();
  const thirtyMinutes = 30 * 60 * 1000;

  if (timestamp <= RELEASE_DATE) return true;

  if (timestamp - createdAt >= thirtyMinutes) return false;

  return true;
});
